import(/* webpackMode: "eager", webpackExports: ["AppCollectionsClient"] */ "/app/components/collections/collections-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/components/layout/product-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
